import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
	const location = useLocation();

	useEffect(() => {
		console.error(
			"404 Error: User attempted to access non-existent route:",
			location.pathname
		);
	}, [location.pathname]);

	return (
		<section className="notfound">
			<Helmet>
				<title>Moonface Techs | 404 - Page Not Found</title>
				<meta name="description" content="Oops! The page you're looking for doesn't exist. Return to Moonface Techs homepage." />
			</Helmet>
			<div className="notfound-container">
				<h1 className="notfound-code" data-text="404">
					404
				</h1>
				<p className="notfound-message">Oops! Page not found.</p>
				<a href="/" className="notfound-link">
					Return to Home
				</a>
			</div>
		</section>
	);
};

export default NotFound;
